import api from "./Api.js";

export default {
	get() {
		return api().get(`schedule-types/`);
	},
};
